import { useTranslation as useReactI18nextTranslation } from 'react-i18next';

/**
 * Custom hook to use translations with German as the default language.
 * Wraps the react-i18next useTranslation hook.
 */
export const useTranslation = () => {
  // Use react-i18next's useTranslation hook
  const { t, i18n } = useReactI18nextTranslation();

  return {
    t,       // Translation function
    i18n,    // i18n instance
    language: i18n.language // Current language (should always be 'de')
  };
};

export default useTranslation; 